import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { Tag, ArrowLeft } from 'lucide-react';
import { DbProduct } from '../../utils/api';
import ProductCard from '../products/ProductCard';

const API_URL = window.location.protocol + '//' + window.location.host + '/api';

const CategoryPage = () => {
  const { name } = useParams<{ name: string }>();
  const catName = decodeURIComponent(name || '');

  const [products, setProducts] = useState<DbProduct[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!catName) return;
    fetch(`${API_URL}/category.php?name=${encodeURIComponent(catName)}`, { credentials: 'include' })
      .then(r => r.json())
      .then(res => {
        if (res.success) setProducts(res.products);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [catName]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-orange-500 border-t-transparent" />
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <Link to="/products" className="inline-flex items-center gap-1 text-gray-500 hover:text-orange-500 text-sm mb-6 transition-colors">
        <ArrowLeft className="w-4 h-4" />
        Zurück
      </Link>

      <div className="bg-gradient-to-r from-gray-800 to-gray-900 rounded-2xl p-8 mb-8 text-white flex items-center gap-4">
        <Tag className="w-8 h-8 text-orange-400" />
        <div>
          <h1 className="text-3xl font-bold">{catName}</h1>
          <p className="text-gray-400 mt-1">{products.length} {products.length === 1 ? 'Angebot' : 'Angebote'}</p>
        </div>
      </div>

      {products.length === 0 ? (
        <p className="text-gray-500 text-center py-8">Keine aktiven Angebote in dieser Kategorie.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map(p => <ProductCard key={p.id} {...p} />)}
        </div>
      )}
    </div>
  );
};

export default CategoryPage;
